
import './Admin.scss';
import { Routes, Route } from 'react-router-dom';
import Login from './Login';
import Main from './Main';

export default function AdminMain() {
  return (
    <div className="AdminContainer">
      <Routes>
        <Route index element={<Login />} />
        <Route path="main" element={<Main />} />
      </Routes>
    </div>
  );
}
